<template>
  <div>
    <v-text-field
      v-model="company.reg_configuration.reminder_time"
      color="saPrimary"
      :label="$t('screener.admin.company.registration.reminder_time')"
      :rules="[
        rules.required,
        rules.numeric,
        rules.inBetween(60, 180, company.reg_configuration.reminder_time),
      ]"
    ></v-text-field>
    <!-- Send Reminder -->
    <v-checkbox
      v-model="company.reg_configuration.send_reminder"
      color="saPrimary"
      :label="$t('screener.admin.company.registration.send_reminder')"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            class="greyDarken3--text body-1"
            v-html="
              $t('screener.admin.company.registration.send_reminder.tooltip')
            "
          ></span>
        </v-tooltip>
      </template>
    </v-checkbox>
    <!-- Verification Required -->
    <v-checkbox
      v-model="company.reg_configuration.verification_required"
      color="saPrimary"
      :label="$t('screener.admin.company.registration.verification_required')"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span class="greyDarken3--text body-1">
            {{
              $t(
                "screener.admin.company.registration.verification_required.tooltip"
              )
            }}
          </span>
        </v-tooltip>
      </template>
    </v-checkbox>
    <!-- Show Mobile Input -->
    <v-checkbox
      v-model="company.reg_configuration.is_mobile_visible"
      color="saPrimary"
      :label="$t('screener.admin.company.registration.is_mobile_visible')"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            class="greyDarken3--text body-1"
            v-html="
              $t(
                'screener.admin.company.registration.is_mobile_visible.tooltip'
              )
            "
          ></span>
        </v-tooltip>
      </template>
    </v-checkbox>
    <!-- Mobile Required -->
    <v-checkbox
      v-model="company.reg_configuration.mobile_required"
      color="saPrimary"
      :label="$t('screener.admin.company.registration.mobile_required')"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            class="greyDarken3--text body-1"
            v-html="
              $t('screener.admin.company.registration.mobile_required.tooltip')
            "
          ></span>
        </v-tooltip>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";

export default {
  name: "AdminCompanyProfileAudience",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { rules };
  },
  watch: {
    company: {
      handler: function () {
        this.$emit("update:company", this.company);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>
